import { Injectable } from '@angular/core';
import {
  DocumentScanner,
  ResponseType,
  ScanDocumentOptions,
  ScanDocumentResponseStatus
} from '@capgo/capacitor-document-scanner';
import { CameraService } from './camera.service';
import { PlatformService } from './platform.service';

export interface DocumentScannerCaptureResult {
  base64Data: string;
  mimeType: string;
  fileName: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentScannerCapacitorService {
  constructor(
    private platformService: PlatformService,
    private cameraService: CameraService
  ) {}

  public async scanDocument(options?: ScanDocumentOptions): Promise<DocumentScannerCaptureResult | null> {
    if (this.platformService.isWeb()) {
      return null;
    }

    if (!(await this.cameraService.ensureCameraPermission())) {
      return null;
    }

    if (await this.platformService.isBelowAndroid13()) {
      if (!(await this.cameraService.ensureLegacyAndroidStoragePermission())) {
        return null;
      }
    }

    const scanOptions: ScanDocumentOptions = {
      ...options,
      responseType: ResponseType.Base64
    };

    try {
      const response = await DocumentScanner.scanDocument(scanOptions);

      if (response.status === ScanDocumentResponseStatus.Cancel || !response.scannedImages?.length) {
        return null;
      }

      const rawBase64 = response.scannedImages[0];
      const base64Data = rawBase64.includes(',') ? rawBase64.split(',')[1] : rawBase64;
      const mimeType = 'image/jpeg';
      const fileName = `document-scan-${Date.now()}.jpg`;

      return {
        base64Data: base64Data.replace(/\s/g, ''),
        mimeType,
        fileName
      };
    } catch (error) {
      if (this.cameraService.isCameraPermissionError(error)) {
        await this.cameraService.notifyCameraPermissionDenied();
        return null;
      }

      throw error;
    }
  }
}
